import { useState } from 'react';
import { NavLink } from 'react-router-dom';

const NavButton = ({ to, children, onClick }) => {
  const linkClassName = ({ isActive }) =>
    `btn btn-ghost ${isActive ? 'text-primary font-bold' : ''}`;

  return (
    <NavLink to={to} className={linkClassName} onClick={onClick}>
      {children}
    </NavLink>
  );
};

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  // Function to close the menu when a link or logo is clicked
  const handleMenuClose = () => {
    setIsMenuOpen(false);
  };

  return (
    <div className="navbar bg-base-100 shadow-md w-full z-50 px-4">
      {/* Logo Section */}
      <div className="flex-1">
        <NavLink to="/" onClick={handleMenuClose} className="flex flex-col items-start">
          <div className="text-2xl font-title font-extrabold leading-tight">
            <span
              style={{ fontFamily: 'Barriecito, sans-serif' }}
              className="text-yellow-400"
            >
              BitBit
            </span>{' '}
            Studio
          </div>
        </NavLink>
      </div>

      {/* Mobile Menu Toggle Button */}
      <div className="flex-none md:hidden">
        <button
          className="btn btn-square btn-ghost"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth="2"
            stroke="currentColor"
            className="w-6 h-6"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M4 6h16M4 12h16m-7 6h7"
            />
          </svg>
        </button>
      </div>

      {/* Desktop Menu */}
      <div className="hidden md:flex space-x-6 px-1">
        <NavButton to="/" onClick={handleMenuClose}>
          Home
        </NavButton>
        <NavButton to="/portfolio" onClick={handleMenuClose}>
          Portfolio
        </NavButton>
        <NavButton to="/about" onClick={handleMenuClose}>
          About
        </NavButton>
        <NavButton to="/services" onClick={handleMenuClose}>
          Services
        </NavButton>
        <NavButton to="/contact" onClick={handleMenuClose}>
          Contact
        </NavButton>
      </div>

      {/* Mobile Menu with Animation */}
      <div
        className={`flex flex-col bg-base-100 p-4 absolute top-16 left-0 w-full overflow-hidden md:hidden transition-all duration-300 ease-in-out ${
          isMenuOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
        }`}
      >
        <NavButton to="/" onClick={handleMenuClose}>
          Home
        </NavButton>
        <NavButton to="/portfolio" onClick={handleMenuClose}>
          Portfolio
        </NavButton>
        <NavButton to="/about" onClick={handleMenuClose}>
          About
        </NavButton>
        <NavButton to="/services" onClick={handleMenuClose}>
          Services
        </NavButton>
        <NavButton to="/contact" onClick={handleMenuClose}>
          Contact
        </NavButton>
      </div>
    </div>
  );
};

export default Navbar;
